export const en = {
    'compact-title': 'Total'
};
